export default __webpack_public_path__ + "static/media/ic_burundi.422f13f3.svg";